import React, { useEffect, useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { Btn } from "../../AbstractElements";
import CustomInput from "../../Component/BasicComponents/CustomInput";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit } from "react-icons/fa";
import {
  useAddSGPITransaction,
  useGetSGPIStatus,
  useTransactionList,
  useUpdateSGPITransaction,
} from "./hooks/useSGPI";
import CustomDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdownPagination";
import { getSGPIAccountFilter, getSGPIFilter } from "./hooks/SGPIRepository";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import PaginatedRouteDropdown from "../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import RouteDropdown from "../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { showToast } from "../../utils/toastUtils";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { COLORS } from "../../constants/colors";

interface OptionType {
  id: number | string;
  label: string | number;
}

const SGPITransaction = () => {
  const [modalVisiable, setModalVisiable] = React.useState(false);
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    limit: 10,
    employee_id: "",
    status: "",
    search: null,
    sgpiname: "",
    transactiontype: "",
    accountname: "",
  });
  const [selectedSGPIName, setSelectedSGPIName] = useState<{
    id: number | string;
    label: string;
  } | null>(null);
  const [selectedAccountName, setSelectedAccountName] = useState<{
    id: number | string;
    label: string;
  } | null>(null);

  const [formValues, setFormValues] = useState({
    transactionType: "",
    qty: "",
    voucher: "",
    remark: "",
  });
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [modalStatus, setModalStatus] = useState<string>("");
  const [SGPITractionId, setSGPITransactionId] = useState<string | number>("");
  const [buttonDisable, setButtonDisable] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
        const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
        const { startPolling, stopPolling } = useExcelPolling();

  const { data: transactionData, isLoading: transactionListLoading } =
    useTransactionList({
      enable: true,
      params: {
        start: filtersState?.page,
        length: filtersState?.limit,
        search: filtersState?.search,
        Type: filtersState?.transactiontype,
        SgpiAccountId: filtersState?.accountname,
        SgpiId: filtersState?.sgpiname,
        sortColumn: "SgpiTranId",
        sortOrder: "DESC",
      },
    });

  const { data: statusSGPIData } = useGetSGPIStatus({
    enable: true,
  });

  const { mutate: addTransaction } = useAddSGPITransaction();
  const { mutate: updateTransaction } = useUpdateSGPITransaction();

  // Formatted Data for the Transaction Type Status
  // ========================================================

  const formattedTransactionTypeData = Object.entries(
    statusSGPIData?.data?.CD || {}
  ).map(([key, value]) => ({
    id: key,
    label: value,
  }));

  const formattedTransactionTypeDataModal = Object.entries(
    statusSGPIData?.data?.CD || {}
  ).map(([key, value]) => ({
    id: key,
    label: value,
  }));

  const formattedTransactionData = [
    { id: "", label: "All" },
    ...formattedTransactionTypeData,
  ];

  const handleEdit = (row: any) => {
    setModalVisiable(!modalVisiable);
    setSelectedRow(row);
    setModalStatus("Edit");
    setSGPITransactionId(row?.SgpiTranId);
    // SgpiTranId
  };

  useEffect(() => {
    console.log("setSelectedRow::::::::::;", selectedRow);

    if (selectedRow) {
      setFormValues({
        transactionType: selectedRow?.Cd,
        voucher: selectedRow?.VoucherNo,
        qty: selectedRow?.Qty,
        remark: selectedRow?.Remark,
      });
      setSelectedAccountName(
        selectedRow?.SgpiAccounts?.SgpiAccountId &&
          selectedRow?.SgpiAccounts?.AccountName
          ? {
              id: selectedRow?.SgpiAccounts?.SgpiAccountId,
              label: selectedRow?.SgpiAccounts?.AccountName,
            }
          : null
      );
      setSelectedSGPIName(
        selectedRow?.SgpiMaster?.SgpiId && selectedRow?.SgpiMaster?.SgpiName
          ? {
              id: selectedRow?.SgpiMaster?.SgpiId,
              label: selectedRow?.SgpiMaster?.SgpiName,
            }
          : null
      );
    }
  }, [selectedRow]);

  const handleClose = () => {
    setButtonDisable(false);
    setModalVisiable(!modalVisiable);
    setFormValues({
      transactionType: "",
      qty: "",
      voucher: "",
      remark: "",
    });
    setSelectedAccountName(null);
    setSelectedSGPIName(null);
    setModalStatus("");
  };
  const toggleModal = () => {
    setButtonDisable(false);
    setModalVisiable(!modalVisiable);
    setFormValues({
      transactionType: "",
      qty: "",
      voucher: "",
      remark: "",
    });
    setSelectedAccountName(null);
    setSelectedSGPIName(null);
    setModalStatus("");
  };

  const handleSubmit = () => {
    if (modalStatus === "Edit") {
      setButtonDisable(true);
      if (!SGPITractionId) {
        setButtonDisable(false);
        showToast.warning("Transaction ID is not Available!");
        return;
      } else if (!selectedSGPIName?.id) {
        setButtonDisable(false);
        showToast.warning("Please Select SGPI Name!");
        return;
      } else if (!selectedAccountName?.id) {
        setButtonDisable(false);
        showToast.warning("Please Select Account Name!");
        return;
      } else if (!formValues?.transactionType) {
        setButtonDisable(false);
        showToast.warning("Please Select Credit / Debit!");
        return;
      } else if (!formValues?.qty.trim()) {
        setButtonDisable(false);
        showToast.warning("Please Fill Quantity Field!");
        return;
      } else if (!formValues?.voucher.trim()) {
        setButtonDisable(false);
        showToast.warning("Please Fill Voucher Number Field!");
        return;
      } else if (Number(formValues?.qty) <= 0) {
        setButtonDisable(false);
        showToast.warning("Quantity Should be Greater than 0!");
        return;
      } else if (!formValues?.remark.trim()) {
        setButtonDisable(false);
        showToast.warning("Please Fill Remark Field!");
        return;
      } else {
        const updateTransactionBody = {
          SgpiId: selectedSGPIName?.id,
          SgpiAccountId: selectedAccountName?.id,
          Cd: formValues?.transactionType,
          Qty: formValues?.qty,
          VoucherNo: formValues?.voucher,
          Remark: formValues?.remark,
        };
        updateTransaction(
          { id: SGPITractionId, body: updateTransactionBody },
          {
            onSuccess: () => {
              handleClose();
            },
            onError: () => {
              setButtonDisable(false);
            },
          }
        );
      }
    } else {
      setButtonDisable(true);
      if (!selectedSGPIName?.id) {
        setButtonDisable(false);
        showToast.warning("Please Select SGPI Name!");
        return;
      } else if (!selectedAccountName?.id) {
        setButtonDisable(false);
        showToast.warning("Please Select Account Name!");
        return;
      } else if (!formValues?.transactionType) {
        setButtonDisable(false);
        showToast.warning("Please Select Credit / Debit!");
        return;
      } else if (!formValues?.qty.trim()) {
        setButtonDisable(false);
        showToast.warning("Please Fill Quantity Field!");
        return;
      } else if (Number(formValues?.qty) <= 0) {
        setButtonDisable(false);
        showToast.warning("Quantity Should be Greater than 0!");
        return;
      } else if (!formValues?.voucher.trim()) {
        setButtonDisable(false);
        showToast.warning("Please Fill Voucher Number Field!");
        return;
      } else if (!formValues?.remark.trim()) {
        setButtonDisable(false);
        showToast.warning("Please Fill Remark Field!");
        return;
      } else {
        const addTransactionBody = {
          SgpiId: selectedSGPIName?.id,
          SgpiAccountId: selectedAccountName?.id,
          Cd: formValues?.transactionType,
          Qty: formValues?.qty,
          VoucherNo: formValues?.voucher,
          Remark: formValues?.remark,
        };

        addTransaction(
          { body: addTransactionBody },
          {
            onSuccess: () => {
              handleClose();
            },
            onError: () => {
              setButtonDisable(false);
            },
          }
        );
      }
    }
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };

  const handleFilter = (key: any, selected: any) => {
    setFiltersState((prev: any) => ({
      ...prev,
      [key]: selected.id === "null" ? null : selected.id,
    }));
  };

  const handleDropdownSelect = (field: string, value: string | number) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      [field]: value, // Directly assign the selected value
    }));
  };

  const handleInputChange = (
    name: any,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    // Convert specific fields to numbers
    const numericFields = ["mobile", "registration"];
    const updatedValue = numericFields.includes(name)
      ? value.replace(/[^0-9]/g, "")
      : value;

    setFormValues((prevState) => ({
      ...prevState,
      [name]: numericFields.includes(name)
        ? updatedValue === ""
          ? ""
          : Number(updatedValue)
        : updatedValue,
    }));
  };
         const downloadExcelGet = async () => {
  const appToken = localStorage.getItem("Apptoken") || "";
    const start= filtersState?.page;
        const length= filtersState?.limit;
        const search= filtersState?.search;
        const Type= filtersState?.transactiontype;
       const SgpiAccountId= filtersState?.accountname;
        const SgpiId= filtersState?.sgpiname;
      //  const sortColumn= "SgpiTranId";
        const sortOrder= "DESC";


    const params = new URLSearchParams();

    // Append only if the value exists

    // if (sortColumn) params.append("sortColumn", sortColumn);
    if (search) params.append("search", search);
    if (Type) params.append("Type", Type);
    if (SgpiAccountId) params.append("SgpiAccountId", SgpiAccountId);
    if (SgpiId) params.append("SgpiId", SgpiId);
    if (sortOrder) params.append("sortOrder", sortOrder);
     const queryString = new URLSearchParams(params).toString();
      try {
        setLoadingExcel(true);
        const response = await axiosInstance.get(
          `${API_ENDPOINTS.SGPI.GET_TRANSACTION_LIST_EXCEL}?${queryString}`
        );
        console.log("responseresponseresponse",response)
        const { success, fileDownloadId, intervalTime } =
          response?.data?.data|| null;
  
        if (success && fileDownloadId) {
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: any) => {
              setLoadingExcel(false);
              setExcelStatus('Loading..');
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (msg: any) => {showToast.error(msg || "");setLoadingExcel(false)},
            onExpired: (msg: any) => showToast.error(msg || ""),
            onDeleted: (msg: any) => showToast.error(msg || ""),
          });
        }
      } catch (err: any) {
        showToast.error(err);
        setLoadingExcel(false)
      }
    };

  return (
    <div className="p-2">
      <PageHeader
        title="Transaction"
        buttons={[
          {
            label: "+ Add Transaction",
            onClick: () => setModalVisiable(!modalVisiable),
            color: "#2e8dd3",
          },
                  {
                                       label: loadingExcel? excelStatus ? excelStatus.charAt(0).toUpperCase() + excelStatus.slice(1) +"..": "": "Excel",
                                        onClick:downloadExcelGet,
                                      color: loadingExcel ? COLORS.disable : COLORS.primary,
                                                  disable: loadingExcel ? true : false,
                                       },
        ]}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "auto",
          marginTop: "2%",
        }}
      >
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <BasicDataTable
            search={true}
            Title="All Transactions"
            columns={dummyData(handleEdit)}
            SearchPlaceholder="Search by SGPI Name"
            dynamicHeightOnRowsPerPage={true}
            data={transactionData?.data?.data || []}
            headerContent={
              <>
                <CustomDropdown
                  placeholder="All"
                  DropdownLabel="SGPI Name"
                  value={filtersState?.sgpiname}
                  onChange={(id) => {
                    setFiltersState((prev: any) => ({
                      ...prev,
                      sgpiname: id,
                      page: 1,
                    }));
                  }}
                  fetchData={async ({ page, limit, search }) => {
                    const res = await getSGPIFilter({
                      start: page,
                      length: limit,
                      search: !search ? "" : search.trim(),
                    });

                    console.log("🚀 ~ SGPIMaster.tsx:404 ~ res:", res?.data);

                    const rawData = res?.data || {};
                    let formatted = Object.entries(rawData).map(
                      (item: any) => ({
                        id: item[0],
                        label: item[1],
                      })
                    );

                    const totaldata = res?.recordsTotal;

                    const hasMore = totaldata > (page + 1) * limit;

                    // ✅ Only add "All" on the first page
                    if (page === 1) {
                      formatted = [{ id: "", label: "All" }, ...formatted];
                    }

                    return {
                      data: formatted,
                      hasMore,
                    };
                  }}
                  includeAllOption
                />
                <RoundedDropdown
                  options={formattedTransactionData || []}
                  onSelect={(e) => handleFilter("transactiontype", e)}
                  defaultLabel="All"
                  width="120px"
                  isShowHeading
                  DropdownHeading="Transaction Type"
                  headingColor="#2e8dd3"
                />
                <CustomDropdown
                  placeholder="All"
                  DropdownLabel="Account Name"
                  value={filtersState?.accountname}
                  onChange={(id: any) => {
                    setFiltersState((prev: any) => ({
                      ...prev,
                      accountname: id,
                      page: 1,
                    }));
                  }}
                  fetchData={async ({ page, limit, search }) => {
                    const res = await getSGPIAccountFilter({
                      start: page,
                      length: limit,
                      search: !search ? "" : search.trim(),
                      sortColumn: "AccountName",
                      sortOrder: "ASC",
                    });

                    const rawData = res?.data || {};
                    let formatted = Object.entries(rawData).map(
                      (item: any) => ({
                        id: item[0],
                        label: item[1],
                      })
                    );

                    const totaldata = res?.recordsTotal;
                    const hasMore = totaldata > (page + 1) * limit;

                    if (page === 1) {
                      formatted = [{ id: "", label: "All" }, ...formatted];
                    }

                    return {
                      data: formatted,
                      hasMore,
                    };
                  }}
                  includeAllOption
                />
              </>
            }
            showSpinner={transactionListLoading}
            onChangePage={(pageNo: number) => {
              handlePagination(pageNo);
            }}
            onChangeRowsPerPage={(newPerPage: any, page: any) => {
              handleonChangeRowsPerPage(newPerPage, page);
            }}
            handleSearch={(val: any) => {
              handleSearch(val);
            }}
            paginationTotalRows={transactionData?.data?.recordsTotal || 0}
          />
        </div>
      </div>

      {modalVisiable && (
        <RouteModal
          isOpen={modalVisiable}
          toggle={toggleModal}
          title={
            modalStatus === "Edit" ? "Edit Transaction" : "Add Transactions"
          }
          size="lg"
          content={
            <div>
              <div
                style={{ borderBottom: "1px solid #dedede", width: "100%" }}
              ></div>
              <div className="row mb-0">
                <div className="col-sm-6">
                  <PaginatedRouteDropdown
                    DropdownHeading="SGPI Name"
                    placeholder="Select SGPI Name"
                    asterisk={true}
                    initialSelectedOptions={selectedSGPIName}
                    onChange={(val: any) => {
                      setSelectedSGPIName(val);
                    }}
                    fetchOptions={async (page: any, search: any) => {
                      const res = await getSGPIFilter({
                        search: search || "",
                        start: page,
                        length: 10,
                      });

                      const rawData = res?.data || {};
                      return Object.entries(rawData).map((item: any) => ({
                        id: item[0],
                        label: item[1],
                      }));
                    }}
                  />
                </div>

                <div className="col-sm-6">
                  <PaginatedRouteDropdown
                    DropdownHeading="Account Name"
                    placeholder="Select Account Name"
                    asterisk={true}
                    initialSelectedOptions={selectedAccountName}
                    onChange={(val: any) => {
                      setSelectedAccountName(val);
                    }}
                    fetchOptions={async (page: any, search: any) => {
                      const res = await getSGPIAccountFilter({
                        search: search || "",
                        start: page,
                        length: 10,
                        sortColumn: "AccountName",
                        sortOrder: "ASC",
                      });

                      const rawData = res?.data || {};
                      return Object.entries(rawData).map((item: any) => ({
                        id: item[0],
                        label: item[1],
                      }));
                    }}
                  />
                </div>

                <div className="col-sm-6">
                  <RouteDropdown
                    options={
                      (formattedTransactionTypeDataModal as OptionType[]) || []
                    }
                    value={formValues?.transactionType}
                    asterisk={true}
                    onChange={(value: any) => {
                      handleDropdownSelect("transactionType", value);
                    }}
                    DropdownHeading="Credit / Debit"
                    placeholder="Select Credit / Debit"
                  />
                </div>

                <div className="col-sm-6">
                  <CustomInput
                    label="Quantity"
                    placeholder="Enter Quantity"
                    asterisk={true}
                    type="number"
                    name="Quantity"
                    value={formValues.qty}
                    onChange={(e) => handleInputChange("qty", e)}
                  />
                </div>
                <div className="col-sm-6">
                  <CustomInput
                    label="Voucher Number"
                    placeholder="Enter Voucher Number"
                    asterisk={true}
                    type="number"
                    name="voucher"
                    value={formValues.voucher}
                    onChange={(e) => handleInputChange("voucher", e)}
                  />
                </div>
                <div className="col-sm-6">
                  <CustomInput
                    label="Remark"
                    placeholder="Enter Remark"
                    asterisk={true}
                    type="text"
                    name="remark"
                    value={formValues.remark}
                    onChange={(e) => handleInputChange("remark", e)}
                  />
                </div>
              </div>
              <br />

              {/* Buttons */}
              <div className="d-flex justify-content-start gap-2">
                <Btn
                  style={{ backgroundColor: "#43B9B2", color: "white" }}
                  type="submit"
                  onClick={handleSubmit}
                  disabled={buttonDisable}
                >
                  {modalStatus === "Edit" ?buttonDisable?"Updating...": "Update" :buttonDisable?"Submitting...": "Submit"}
                </Btn>
                <Btn
                  style={{
                    backgroundColor: "#F9FAFC",
                    color: "#000",
                    border: "1px solid #E0E0E0",
                  }}
                  type="button"
                  onClick={handleClose}
                >
                  Cancel
                </Btn>
              </div>
            </div>
          }
        />
      )}
    </div>
  );
};
export default SGPITransaction;
const dummyData = (handleEdit: (row: any) => void) => [
  {
    name: "SGPI Tran Id",
    selector: (row: { SgpiTranId: number | string }) => row?.SgpiTranId ?? "-",
    minWidth: "150px",
    sortable: true,
    wrap: true,
  },

  {
    name: "SGPI Name",
    selector: (row: any) => row?.SgpiMaster?.SgpiName ?? "-",
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "Emp Name | Emp Code",
    selector: (row: any) => {
      const employeeFullName = `${row?.EmployeeData?.FirstName.trim()} ${row?.EmployeeData?.LastName.trim()}`;
      const employeeCode = `${row?.EmployeeData?.EmployeeCode}`;
      const empNameAndCode = `${employeeFullName} | ${employeeCode}`;
      return empNameAndCode ?? "-";
    },
    minWidth: "210px",
    sortable: true,
    wrap: true,
  },
  {
    name: "Transaction Type",
    selector: (row: { cdType: string }) => row?.cdType ?? "-",
    sortable: true,
    minWidth: "180px",
  },

  {
    name: "Quantity",
    selector: (row: { Qty: string }) => row?.Qty || "-",
    sortable: true,
    minWidth: "120px",
    wrap: true,
  },
  {
    name: "Voucher No",
    selector: (row: { VoucherNo: string }) => row?.VoucherNo ?? "-",
    sortable: true,
    minWidth: "180px",
  },

  {
    name: "Created At",
    selector: (row: { CreatedAt: string }) =>
      row?.CreatedAt ? row.CreatedAt.split(".")[0] : "-",
    wrap: true,
    minWidth: "180px",
    sortable: true,
  },

  {
    name: "Remark",
    selector: (row: { Remark: string }) => row?.Remark || "-",
    wrap: true,
    minWidth: "180px",
    sortable: true,
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <button
        onClick={() => handleEdit(row)}
        className="btn btn-primary"
        style={{
          borderRadius: "20px",
          padding: "5px",
          width: "80px",
          fontSize: "14px",
        }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];
